import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { ActivatedRoute, RouterLink, RouterLinkActive } from '@angular/router';
import { IconComponent } from 'src/app/core/components/icon/icon.component';
import { Filter } from 'src/app/shop/models/filter.model';

@Component({
  selector: 'app-product-featured-filter-row',
  imports: [RouterLink, RouterLinkActive, IconComponent],
  templateUrl: './product-featured-filter-row.component.html',
  styleUrl: './product-featured-filter-row.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ProductFeaturedFilterRowComponent {
  private route = inject(ActivatedRoute);
  private queryParamMap = toSignal(this.route.queryParamMap);

  filter = input<Filter>();

  filterItems = computed(() => this.filter()?.values?.filter(a => a.count > 0) || []);

  activeQueryParam = computed(() => this.queryParamMap()?.get(this.filter()?.id.replace(/\./g, '-') ?? '') ?? '');

  filterParam(value: string) {
    const filterId = this.filter()?.id.replace(/\./g, '-');

    if (!filterId) return {};

    if (this.activeQueryParam() === value) {
      return {
        [filterId]: null,
      };
    }

    return {
      [filterId]: value,
    };
  }
}
